import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ed87eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Admin" }
const _hoisted_2 = { class: "routerlink" }
const _hoisted_3 = { class: "Admin_Container" }
const _hoisted_4 = { class: "Admin_Wrapper" }
const _hoisted_5 = {
  class: "Admin_Form",
  style: {"gap":"10px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Admin_Form_Title" }, "アカウント作成", -1))
const _hoisted_7 = { class: "error_message" }
const _hoisted_8 = { class: "error_message" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { style: {"width":"233px"} }, "権限"),
  /*#__PURE__*/_createElementVNode("select", { style: {"width":"233px"} }, [
    /*#__PURE__*/_createElementVNode("option", { selected: "" }, "member"),
    /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "ADMIN")
  ])
], -1))
const _hoisted_10 = { class: "Admin_Form" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Admin_Form_Title" }, "パスワード変更", -1))
const _hoisted_12 = { class: "error_message" }
const _hoisted_13 = { class: "error_message" }
const _hoisted_14 = { class: "error_message" }
const _hoisted_15 = {
  class: "Admin_Form Admin_BtnBlock",
  style: {"gap":"4px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "Admin_Form_Title",
  style: {"padding":"8px 0px"}
}, " データ取込・出力 ", -1))
const _hoisted_17 = {
  key: 0,
  class: "loading"
}
const _hoisted_18 = {
  key: 0,
  class: "loading"
}
const _hoisted_19 = {
  key: 0,
  class: "loading"
}
const _hoisted_20 = {
  key: 0,
  class: "loading"
}
const _hoisted_21 = {
  key: 0,
  class: "loading"
}
const _hoisted_22 = {
  key: 0,
  class: "loading"
}
const _hoisted_23 = {
  key: 0,
  class: "loading"
}
const _hoisted_24 = {
  key: 0,
  class: "loading"
}
const _hoisted_25 = {
  key: 0,
  class: "loading"
}
const _hoisted_26 = {
  key: 0,
  class: "loading"
}
const _hoisted_27 = {
  key: 0,
  class: "loading"
}
const _hoisted_28 = {
  key: 0,
  class: "loading"
}
const _hoisted_29 = {
  key: 0,
  class: "loading"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn_disabled" }, "共通リスト取込", -1))

import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import axios from "axios";
import { isValidPassword } from "../functions/Validation.js";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import InputText from "../components/atoms/Input/InputText.vue";

type NewAccount = typeof newAccount.value;

type DisableData = typeof disableData.value;


export default /*#__PURE__*/_defineComponent({
  __name: 'Admin',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const notyf = new Notyf();

emit("toggleGlobalHeader");

const setBaseUrl = () => {
  store.commit("setBaseUrl");
};
setBaseUrl();

//パスワード変更--------------------------------------
let mailAddress = ref("");
let password = ref("");
let passwordsub = ref("");
const mailInput = (e: string) => {
  mailAddress.value = e;
};
const passInput = (e: string) => {
  password.value = e;
};
const passwordsubInput = (e: string) => {
  passwordsub.value = e;
};
const updatePassWord = async () => {
  validateUpdateError();
  if (hasUpdateError.value) {
    return;
  }
  try {
    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/account/updatePasswordByAdmin?password=${password.value}&email=${mailAddress.value}`,
      "",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.data === "OK") {
      password.value = "";
      mailAddress.value = "";
      passwordsub.value = "";
      notyf.success("パスワードを変更しました");
    } else {
      notyf.error(res.data);
    }
  } catch (error) {
    alert("パスワードの変更に失敗しました");
    console.log(error);
  }
};
let hasUpdateError = ref(false);
let updateErrorMessage = reactive({
  email: "",
  password: "",
  passwordsub: "",
});

//パスワード更新のバリデーション
const validateUpdateError = () => {
  hasUpdateError.value = false;
  updateErrorMessage.email = "";
  updateErrorMessage.password = "";
  updateErrorMessage.passwordsub = "";
  if (mailAddress.value === "") {
    updateErrorMessage.email = "メールアドレスを入力してください";
    hasUpdateError.value = true;
  }
  //パスワードは半角英数字、半角記号(_@-/.)
  if (!isValidPassword(password.value)) {
    // console.log(isValidPassword(password.value));
    updateErrorMessage.password =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasUpdateError.value = true;
  }
  if (!isValidPassword(passwordsub.value)) {
    // console.log(isValidPassword(passwordsub.value));
    updateErrorMessage.passwordsub =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasUpdateError.value = true;
  }
  if (password.value !== passwordsub.value) {
    hasUpdateError.value = true;
    notyf.error("確認用パスワードが異なっています");
  }
};
//アカウント作成------------------------------------
const newAccount = ref({
  email: "",
  username: "",
  password: "",
  passwordsub: "",
  hanmotoCd: "",
  role: "member", //管理者アカウントは現状1つだけなのでmenber固定
});
// 型
const newAccountInput = (e: string, key: keyof NewAccount) => {
  newAccount.value[key] = e;
};
const createAccount = async () => {
  if (hasEmptyInput()) {
    notyf.error("アカウント作成欄の全項目を入力してください");
    return;
  }
  validateCreateError();
  if (hasCreateError.value) {
    return;
  }
  const postData = { ...newAccount.value };
  try {
    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/account/signin`,
      postData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.data === "OK") {
      notyf.success("アカウントを作成しました");
      Object.keys(newAccount.value).forEach(function (key) {
        newAccount.value[key as keyof NewAccount] = "";
      });
    } else {
      notyf.error(res.data);
    }
  } catch (error) {
    alert("アカウントの作成に失敗しました");
    console.log(error);
  }
};
const hasEmptyInput = () => {
  return (
    newAccount.value.username === "" ||
    newAccount.value.email === "" ||
    newAccount.value.password === "" ||
    newAccount.value.passwordsub === "" ||
    newAccount.value.hanmotoCd === "" ||
    newAccount.value.role === ""
  );
};
let hasCreateError = ref(false);
let createErrorMessage = reactive({
  email: "",
  password: "",
  passwordsub: "",
});
const validateCreateError = () => {
  hasCreateError.value = false;
  createErrorMessage.password = "";
  createErrorMessage.passwordsub = "";
  //パスワードは半角英数字、半角記号(_@-/.)
  if (!isValidPassword(newAccount.value.password)) {
    // console.log(isValidPassword(newAccount.value.password));
    createErrorMessage.password =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasCreateError.value = true;
  }
  if (!isValidPassword(newAccount.value.passwordsub)) {
    // console.log(isValidPassword(newAccount.value.passwordsub));
    createErrorMessage.passwordsub =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasCreateError.value = true;
  }
  if (newAccount.value.password !== newAccount.value.passwordsub) {
    hasCreateError.value = true;
    notyf.error("確認用パスワードが異なっています");
  }
};

//バッチ処理---------------------------------
let disableData = ref({
  zaiko: false,
  syosi: false,
  syukko: false,
  choseiInput: false,
  uploadJuchuData: false,
  choseiOutput: false,
  uploadSyosiAddData: false,
  toritugiSyoten: false,
  torioki: false,
  shinagireInput: false,
  shinagireKaijo: false,
  henpinDenpyouInput: false,
  nouhinDenpyouInput: false,
});
let isLoadingData = ref({
  zaiko: false,
  syosi: false,
  syukko: false,
  choseiInput: false,
  uploadJuchuData: false,
  choseiOutput: false,
  uploadSyosiAddData: false,
  toritugiSyoten: false,
  torioki: false,
  shinagireInput: false,
  shinagireKaijo: false,
  henpinDenpyouInput: false,
  nouhinDenpyouInput: false,
});
// 型
const batchData = async (urlName: keyof DisableData, dataName: string) => {
  try {
    disableData.value[urlName] = true;
    isLoadingData.value[urlName] = true;
    await axios.post(`${store.state.baseUrl}/select/batch/${urlName}`, "", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    notyf.success(dataName + "が完了しました");
    isLoadingData.value[urlName] = false;
  } catch (e) {
    notyf.error(dataName + "に失敗しました");
    console.log(e);
    disableData.value[urlName] = false;
    isLoadingData.value[urlName] = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode(" ホームに戻る")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "ユーザー名",
            value: newAccount.value.username,
            onOnInput: _cache[0] || (_cache[0] = ($event: any) => (newAccountInput($event, 'username')))
          }, null, 8, ["value"]),
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "メールアドレス",
            value: newAccount.value.email,
            onOnInput: _cache[1] || (_cache[1] = ($event: any) => (newAccountInput($event, 'email')))
          }, null, 8, ["value"]),
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "パスワード",
            type: "password",
            value: newAccount.value.password,
            onOnInput: _cache[2] || (_cache[2] = ($event: any) => (newAccountInput($event, 'password')))
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(createErrorMessage).password), 1),
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "パスワード(確認用)",
            type: "password",
            value: newAccount.value.passwordsub,
            onOnInput: _cache[3] || (_cache[3] = ($event: any) => (newAccountInput($event, 'passwordsub')))
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(createErrorMessage).passwordsub), 1),
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "版元コード",
            value: newAccount.value.hanmotoCd,
            onOnInput: _cache[4] || (_cache[4] = ($event: any) => (newAccountInput($event, 'hanmotoCd')))
          }, null, 8, ["value"]),
          _hoisted_9,
          _createVNode(BtnGreen, {
            class: "Admin_Form_BtnGreen",
            onClick: createAccount
          }, {
            default: _withCtx(() => [
              _createTextVNode("作成")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "変更対象のメールアドレス",
            value: _unref(mailAddress),
            onOnInput: mailInput
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(updateErrorMessage).email), 1),
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "パスワード",
            type: "password",
            value: _unref(password),
            onOnInput: passInput
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(updateErrorMessage).password), 1),
          _createVNode(InputText, {
            class: "Admin_Form_Input",
            placeholder: "パスワード(確認用)",
            type: "password",
            value: _unref(passwordsub),
            onOnInput: passwordsubInput
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(updateErrorMessage).passwordsub), 1),
          _createVNode(BtnGreen, {
            class: "Admin_Form_BtnGreen",
            onClick: updatePassWord
          }, {
            default: _withCtx(() => [
              _createTextVNode("変更")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).zaiko,
            class: _normalizeClass({ btn_disabled: _unref(disableData).zaiko }),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (batchData('zaiko', '在庫データ取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).zaiko)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                : _createCommentVNode("", true),
              _createTextVNode("在庫データ取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).syosi,
            class: _normalizeClass({ btn_disabled: _unref(disableData).syosi }),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (batchData('syosi', '書誌データ取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).syosi)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                : _createCommentVNode("", true),
              _createTextVNode("書誌データ取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).syukko,
            class: _normalizeClass({ btn_disabled: _unref(disableData).syukko }),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (batchData('syukko', '出庫データ取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).syukko)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                : _createCommentVNode("", true),
              _createTextVNode("出庫データ取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).choseiInput,
            class: _normalizeClass({ btn_disabled: _unref(disableData).choseiInput }),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (batchData('choseiInput', '調整データ取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).choseiInput)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                : _createCommentVNode("", true),
              _createTextVNode("調整データ取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).shinagireInput,
            class: _normalizeClass({ btn_disabled: _unref(disableData).shinagireInput }),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (batchData('shinagireInput', '品切保留取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).shinagireInput)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                : _createCommentVNode("", true),
              _createTextVNode("品切保留取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).nouhinDenpyouInput,
            class: _normalizeClass({ btn_disabled: _unref(disableData).nouhinDenpyouInput }),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (batchData('nouhinDenpyouInput', '納品伝票取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).nouhinDenpyouInput)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                : _createCommentVNode("", true),
              _createTextVNode("納品伝票取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).henpinDenpyouInput,
            class: _normalizeClass({ btn_disabled: _unref(disableData).henpinDenpyouInput }),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (batchData('henpinDenpyouInput', '返品伝票取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).henpinDenpyouInput)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                : _createCommentVNode("", true),
              _createTextVNode("返品伝票取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).uploadJuchuData,
            class: _normalizeClass({ btn_disabled: _unref(disableData).uploadJuchuData }),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (batchData('uploadJuchuData', '受注データ出力')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).uploadJuchuData)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                : _createCommentVNode("", true),
              _createTextVNode("受注データ出力")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).choseiOutput,
            class: _normalizeClass({ btn_disabled: _unref(disableData).choseiOutput }),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (batchData('choseiOutput', '調整データ出力')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).choseiOutput)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                : _createCommentVNode("", true),
              _createTextVNode("調整データ出力")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).uploadSyosiAddData,
            class: _normalizeClass({ btn_disabled: _unref(disableData).uploadSyosiAddData }),
            onClick: _cache[14] || (_cache[14] = ($event: any) => (batchData('uploadSyosiAddData', '書誌追加データ出力')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).uploadSyosiAddData)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                : _createCommentVNode("", true),
              _createTextVNode("書誌追加データ出力")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).shinagireKaijo,
            class: _normalizeClass({ btn_disabled: _unref(disableData).shinagireKaijo }),
            onClick: _cache[15] || (_cache[15] = ($event: any) => (batchData('shinagireKaijo', '品切保留解除出力')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).shinagireKaijo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                : _createCommentVNode("", true),
              _createTextVNode("品切保留解除出力")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).toritugiSyoten,
            class: _normalizeClass({ btn_disabled: _unref(disableData).toritugiSyoten }),
            onClick: _cache[16] || (_cache[16] = ($event: any) => (batchData('toritugiSyoten', '取次書店取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).toritugiSyoten)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                : _createCommentVNode("", true),
              _createTextVNode("取次書店取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createVNode(BtnGreen, {
            disabled: _unref(disableData).torioki,
            class: _normalizeClass({ btn_disabled: _unref(disableData).torioki }),
            onClick: _cache[17] || (_cache[17] = ($event: any) => (batchData('torioki', '取置取込')))
          }, {
            default: _withCtx(() => [
              (_unref(isLoadingData).torioki)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                : _createCommentVNode("", true),
              _createTextVNode("取置取込")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _hoisted_30
        ])
      ])
    ])
  ]))
}
}

})